/** The workflow state of a document. Distinct from its business status. */
export const DOCUMENT_STATUS = ['DRAFT', 'IN_REVIEW', 'APPROVED', 'CANCELLED'] as const
export type DocumentStatus = (typeof DOCUMENT_STATUS)[number]

/**
 * The state of one allocation in the ledger. Never stored — always derived
 * from the consuming document's status, so cancelling a GRN releases its
 * allocation with no update to the link row.
 */
export const LINK_STATE = ['DRAFT', 'IN_REVIEW', 'APPROVED', 'PRE_CLOSED', 'CANCELLED'] as const
export type LinkState = (typeof LINK_STATE)[number]

export const PERMISSION_LEVEL = ['NONE', 'READ', 'WRITE', 'APPROVE', 'ADMIN'] as const
export type PermissionLevel = (typeof PERMISSION_LEVEL)[number]

export const SEVERITY = ['BLOCK', 'OVERRIDE', 'WARN', 'INFO'] as const
export type Severity = (typeof SEVERITY)[number]

export const TAB = ['summary', 'related', 'revisions', 'form', 'drive'] as const
export type TabKey = (typeof TAB)[number]

export const ACTION = [
  'save', 'submit', 'approve', 'reject', 'cancel', 'update', 'print', 'clone', 'email',
  // docs/02 §4e — the accounting system, from the document rather than from an
  // admin screen. Whoever is looking at the invoice is who notices it never
  // reached the books.
  'resync', 'stopSync',
  // docs/06 §4 — two things that change on an APPROVED document without
  // reopening it: a rate agreed after the fact, and the GSTIN it is filed
  // under. Reopening would revise the document; these do not.
  'changeCurrency', 'changeTaxUnit',
  // The running account annexure, downloaded from a billing request before any
  // invoice exists and from the invoice afterwards (docs/video-notes/06 §6).
  'raBill',
  // One mixed challan becomes two: the billable one the customer signs at the
  // gate, and the internal one for support material (docs/video-notes/06 §2).
  'splitBillable',
  // docs/02 §4 — close what is left of an approved order or request without
  // fulfilling it, and undo that ("Pre Close" / "Reopen").
  'preClose', 'undoPreClose',
] as const
export type ActionKey = (typeof ACTION)[number]

/** The GST portal's Unit Quantity Codes, and what our own units map to. */
export * from './uqc.js'
